import config from '../config';

// #189 (ra#499 S3): the portal's own static files (themes, fonts). The same
// branch as ThemeProvider, on the dependency-free runtime config: the sandboxed
// preview must never import utils/helpers.tsx (it reads localStorage at load).
export const assetBase = (): string =>
  (config.envType || 'local') === 'local' ? '' : config.baseName || '';

export const fontBase = (): string => `${assetBase()}/fonts`;
